module.exports = __webpack_public_path__ + "static/choose your uni-98e384c1b2e47e2f3b43100a59edd4d8.svg";